import styled, { css, DefaultTheme } from 'styled-components';
import {
  ActionItemIntent,
  ActionItemStyledProps,
  ActionListProps,
} from './ActionList.typed';

// Todo some effect/animation ?
const selectedItem = css`
  background: #fff;
  font-weight: 700;
  border: 2px solid #000;
`;

const getColourFromIntent = (
  theme: DefaultTheme,
  intent?: ActionItemIntent,
) => {
  switch (intent) {
    case ActionItemIntent.DANGER:
      return theme.brand.error.base;
    default:
      return '#333';
  }
};

export const ActionList = styled.ul<ActionListProps>`
  display: flex;
  flex-direction: column;
  // short term solution as Design want the height to be the length of the screen - most of the time the user is halfway down the page so the following calc is used
  max-height: calc(60vh - 100px);
  overflow-y: auto;
`;

export const ActionItem = styled.button<ActionItemStyledProps>`
  width: 100%;
  padding: 16px 12px;
  font-size: 14px;
  color: ${({ intent, theme }) => getColourFromIntent(theme, intent)};
  background: #fff;
  border-radius: 4px;
  flex-direction: row;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;

  :hover {
    background: #f2f2f2;
    cursor: pointer;
  }
  :focus-visible {
    text-decoration: underline;
  }
  :disabled {
    color: ${({ theme }) => theme.brand.secondary.base};
    cursor: not-allowed;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.brand.secondary.base};
      cursor: not-allowed !important;
    `}

  ${({ isSelected }) => isSelected && selectedItem}
`;

export const ActionDivider = styled.li`
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
`;

export const Trailing = styled.span`
  margin-left: auto;
  line-height: 0;
`;

export const Leading = styled.span`
  line-height: 0;
`;
